import React from 'react'
import GuranteeImg from '../../assets/guarantee-seal.webp.png'

import { icons } from '../../constant/Data'

const GuranteeLicence = () => {
    return (
        // <div className="max-w-5xl mx-auto p-8 bg-white rounded-2xl border shadow-lg relative">

        //     <div className="flex flex-col items-center text-center relative z-10">
        //         {/* Money Back Seal */}
        //         <div className="w-44 h-44 mb-6">
        //             <img
        //                 src={GuranteeImg}
        //                 alt="100% Money Back Guarantee Seal"
        //                 className="w-44 h-44 object-contain"
        //             />
        //         </div>

        //         {/* Headings */}
        //         <h2 className="md:text-4xl text-2xl font-bold text-gray-900 mb-2">
        //             100% Satisfaction or Your Money Back
        //         </h2>
        //         <h3 className="md:text-3xl text-xl font-bold text-[#1e3a8a] mb-6">
        //             90-Day Guarantee
        //         </h3>

        //         {/* Description */}
        //         <p className="max-w-3xl text-gray-700 mb-10 text-lg leading-relaxed">
        //             We're so confident you'll achieve incredible results that we back Sinoclear with a 100% satisfaction guarantee for 180 days. Start using it as soon as it arrives, and within days, you may notice an increase in energy, a clearer mind, and reduced cravings. As you continue your journey, you could start to see gradual weight loss and a reduction in stubborn fat, making it the perfect time to track your progress. If after several weeks or even months you're not completely satisfied, we'll refund your money in full. With Sinoclear, you're truly in control of your weight loss journey.
        //         </p>

        //         {/* Certification Icons */}
        //         <div className="flex justify-center flex-wrap gap-2">
        //             {[
        //                 { name: 'GMP Certified', img: GMP },
        //                 { name: 'FDA Approved', img: FDA },
        //                 { name: 'Natural Ingredients', img: GMO },
        //                 { name: 'USA Manufactured', img: NAT },
        //                 { name: 'GMO Free', img: USA }
        //             ].map((cert, index) => (
        //                 <div
        //                     key={index}
        //                     className="w-20 h-20 rounded-full flex items-center justify-center p-0.5"
        //                 >
        //                     <div className="bg-white rounded-full w-full h-full flex items-center justify-center">
        //                         <img
        //                             src={cert.img}
        //                             alt={cert.name}

        //                             className="w-16 h-16 object-contain"
        //                         />
        //                     </div>
        //                 </div>
        //             ))}
        //         </div>
        //     </div>
        // </div>
        <div class="max-w-7xl mx-auto p-8  bg-[#FAFCFF] rounded-2xl border shadow-lg relative">
            <div class="flex flex-col items-center text-center relative z-10">
                {/* <!-- Money Back Seal --> */}
                <div class="w-44 h-44 mb-6 flex justify-center">
                    <img src={GuranteeImg} alt="100% Money Back Guarantee Seal" class="md:w-44 md:h-44 w-36 h-36 object-contain hover:rotate-2 duration-300 ease-in-out hover:opacity-90"/>
                </div>

                {/* <!-- Headings --> */}
                <h2 class="md:text-4xl text-2xl font-bold text-gray-900 mb-2">
                    100% Satisfaction or Your Money Back
                </h2>
                <h3 class="md:text-3xl text-xl font-bold text-[#1e3a8a] mb-6">
                    180-Day Guarantee
                </h3>

                {/* <!-- Description --> */}
                <p class="max-w-3xl text-gray-700 mb-10 text-lg leading-relaxed">
                    We’re confident you’ll love Sinoclear. Every bottle is backed by our ironclad 180-day
                    guarantee. Whether you notice results in days or weeks, you’re covered. If you’re not
                    satisfied, we’ll refund your full purchase—no questions asked.
                </p>

                {/* <!-- Certification Icons --> */}
                {/* <div class="flex justify-center items-center md:gap-2 gap-1">
                            <div class="md:w-20 md:h-20 h-12 w-12 rounded-full flex items-center justify-center p-0.5">
                                <div class="bg-white rounded-full w-full h-full flex items-center justify-center">
                                    <img src="./assets/Figure → gmp.png.png" alt="GMP Certified" class="w-16 h-16 object-contain hover:opacity-90 duration-300 transition ease-in-out">
                                </div>
                            </div>
                            <div class="md:w-20 md:h-20 h-12 w-12 rounded-full flex items-center justify-center p-0.5">
                                <div class="bg-white rounded-full w-full h-full flex items-center justify-center">
                                    <img src="./assets/Figure → fda.png.png" alt="FDA Approved" class="w-16 h-16 object-contain hover:opacity-90 duration-300 transition ease-in-out">
                                </div>
                            </div>
                            <div class="md:w-20 md:h-20 h-12 w-12 rounded-full flex items-center justify-center p-0.5">
                                <div class="bg-white rounded-full w-full h-full flex items-center justify-center">
                                    <img src="./assets/Figure → gmo.png.png" alt="Natural Ingredients" class="w-16 h-16 object-contain hover:opacity-90 duration-300 transition ease-in-out">
                                </div>
                            </div>
                            <div class="md:w-20 md:h-20 h-12 w-12 rounded-full flex items-center justify-center p-0.5">
                                <div class="bg-white rounded-full w-full h-full flex items-center justify-center">
                                    <img src="./assets/Figure → nat.png.png" alt="USA Manufactured" class="w-16 h-16 object-contain hover:opacity-90 duration-300 transition ease-in-out">
                                </div>
                            </div>
                            <div class="md:w-20 md:h-20 h-12 w-12 rounded-full flex items-center justify-center p-0.5">
                                <div class="bg-white rounded-full w-full h-full flex items-center justify-center">
                                    <img src="./assets/Figure → usa.png.png" alt="GMO Free" class="w-16 h-16 object-contain hover:opacity-90 duration-300 transition ease-in-out">
                                </div>
                            </div>
                        </div> */}

                <div className="flex justify-center items-center md:gap-2 gap-1">
                    {icons.map((icon, index) => (
                        <div
                            key={index}
                            className="md:w-20 md:h-20 h-12 w-12 rounded-full flex items-center justify-center p-0.5"
                        >
                            <div className="bg-white rounded-full w-full h-full flex items-center justify-center">
                                <img
                                    src={icon.src}
                                    alt={icon.alt}
                                    className="w-16 h-16 object-contain hover:opacity-90 duration-300 transition ease-in-out"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    )
}

export default GuranteeLicence
